import { FC } from 'react'
import { Typography } from '@mui/material'
import { DialogNames } from 'src/enums'
import { SensorModal } from './sensorModal'

interface Props {
  sensorDeviceId: string
  onSubmit: () => void
  onCancel: () => void
  isLoading?: boolean
  deviceType?: 'sensor' | 'gateway'
  sensorStateName?: string
  contractorName?: string
  projectName?: string
}

export const MarkLostSensorModal: FC<Props> = ({ sensorDeviceId, onSubmit, onCancel, isLoading = false, deviceType = 'sensor', sensorStateName, contractorName, projectName }) => {
  const getContent = () => {
    const device = deviceType || 'sensor'
    if (sensorStateName === 'in-use' && projectName && contractorName) {
      return (
        <Typography variant="h6">
          Attention: The {device} you're going to mark as lost will be disconnected from the {projectName} project and unassigned from the {contractorName} contractor. Are you sure
          you want to proceed?
        </Typography>
      )
    }

    if (sensorStateName === 'assigned' && contractorName) {
      return (
        <Typography variant="h6">
          Attention: The {device} you're going to mark as lost will be unassigned from the {contractorName} contractor. Are you sure you want to proceed?
        </Typography>
      )
    }

    return (
      <Typography variant="h6">
        Are you sure you want to mark the {device} "{sensorDeviceId}" as lost?
      </Typography>
    )
  }

  return (
    <SensorModal dialogName={DialogNames.MarkLostSensor} onSubmit={onSubmit} onCancel={onCancel} isLoading={isLoading} actionButtonName="Mark as lost" content={getContent()} />
  )
}
